import React from 'react';
import { Button, FormControl, InputLabel } from '@material-ui/core';
import { reduxForm, Field } from 'redux-form/immutable';
import { useDispatch } from 'react-redux';

import StepperComponent, { Stepper } from 'retired/Stepper';
import FormLocationSelector from 'retired/FormLocationSelector';
import Location from 'entities/location/model';
import { PureRender } from 'utils/component-helpers';

import { FORM_IDENTIFIER } from './constants';
import { saveEventAction } from './actions';

interface Props {
  handleSubmit: (handler: (formData: any) => void) => (formData: any) => void;
  isExternal: boolean;
  locations: Location[];
}

const SharedDeedForm = ({ handleSubmit, isExternal, locations }: Props) => {
  const dispatch = useDispatch();
  const onSubmit = (formData: any): void => {
    dispatch(saveEventAction(formData.toJS()));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stepper orientation="vertical">
        <StepperComponent labelText="Event Location" componentIndex={0}>
          <FormControl style={{ width: '100%', height: 20 }}>
            <InputLabel shrink>
              If this event should be available only to users from a specific location, select the
              location here:
            </InputLabel>
          </FormControl>
          <Field
            name="allowedLocations"
            component={FormLocationSelector}
            disabled={isExternal}
            props={{ locations, expanded: false }}
            style={{ marginRight: 10, marginBottom: 10 }}
            fullWidth
          />
        </StepperComponent>
        <StepperComponent labelText="Review" componentIndex={1} currentStep={1} finalStep>
          <div>
            <p>
              Take time to review the information you entered, then select Submit to save your
              changes.
            </p>
            <Button type="submit" color="primary" variant="contained">
              Submit
            </Button>
          </div>
        </StepperComponent>
      </Stepper>
    </form>
  );
};

export default reduxForm({
  form: FORM_IDENTIFIER,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  persistentSubmitErrors: true,
})(PureRender(SharedDeedForm));
